import React from 'react';

const CheckBox = ({ id, label, name, required, checked, onChange, className = 'mb-20', hideCheckbox }) => {
  return (
    <div
      className={`custom-checkbox ${className} ${checked ? 'form-checked' : ''} ${
        hideCheckbox ? '' : 'custom-control'
      }`}
    >
      {!hideCheckbox && (
        <input
          id={id}
          name={name}
          type='checkbox'
          className='custom-control-input'
          required={required}
          checked={checked}
          onChange={onChange}
          disabled={hideCheckbox}
        />
      )}
      {label && (
        <label className={`custom-control-label fw-400 ${hideCheckbox ? '' : 'pl-6 pl-md-4'}`} htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  );
};

export default CheckBox;
